<template>
  <div id="sidenav">
    <div id="sidenav-first-level">
      <div id="section" :class="['sidenav-item', { active: currentNavBar === 'Landing' }]" @click="back">
        <i
          class="fas fa-arrow-left"
          :class="{
            'fa-arrow-left': sectionActive,
            'fa-bars': !sectionActive,
          }"
        ></i>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <component id="sidenav-content" :is="reference"></component>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Mixin from '@/components/Mixin.js'

export default {
  name: 'SideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.component' },
  mixins: [Mixin],
  computed: {
    ...mapGetters('landing', { sectionActive: 'active' }),
    ...mapGetters('landing', ['currentNavBar']),
    reference() {
      const sidenav = this.currentNavBar || 'Landing'
      return () => import(`@/components/sidenav/${sidenav}SideNav.vue`)
    },
  },
  methods: {
    ...mapActions('landing', ['setActive', 'setCurrentNavBar']),
    back() {
      const elements = ['Panel', 'widget/Form']

      if (this.currentNavBar === 'Landing') {
        if (['Section', 'Tabs', 'HeroSparkBanner'].includes(this.sectionActive.type)) {
          this.setActive()
        }

        if (elements.includes(this.sectionActive.type)) {
          const parentId = [...this.sectionActive.path].pop()

          this.setActive(parentId)
        }
      } else {
        this.setCurrentNavBar('Landing')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#sidenav {
  width: 360px;
  height: calc(100vh - 64px);
  background: white;
  display: flex;

  #sidenav-first-level {
    width: 48px;
    height: 100%;
    background: #262626;
    position: relative;
    z-index: 2;

    .sidenav-item {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      width: 48px;
      height: 48px;
      color: white;

      cursor: pointer;

      &.active {
        position: relative;
        &:before {
          content: '';
          background: $cherry;
          width: 5px;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
  }

  #sidenav-content {
    height: 100%;
    width: 312px;
    overflow-y: auto;
    flex: 1;
    border-right: 1px solid #262633;
    position: relative;
    z-index: 1;
  }
}
</style>
